// src/components/ProductGrid.js
import React from "react";
import ProductCard from "./ProductCard";

export default function ProductGrid({ products = [] }) {
  return (
    <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {products.map(p => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  );
}
